import script from "./cube-outline.vue?vue&type=script&setup=true&lang=js"
export * from "./cube-outline.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__